var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action-button",on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('img',{attrs:{"src":_vm.url,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }